export const isRetired = (birthdate, specificDate, targetRetirementAge) =>
  calculateAgeOnDate(birthdate, specificDate) >= targetRetirementAge;

export const calculateAgeOnDate = (birthdate, specificDate) => {
  const specificDateDate = new Date(specificDate);

  // Calculate the user's age
  let age = specificDateDate.getFullYear() - birthdate.getFullYear();

  // Check if the birthday hasn't occurred yet this year
  if (
    specificDateDate.getMonth() < birthdate.getMonth() ||
    (specificDateDate.getMonth() === birthdate.getMonth() &&
      specificDateDate.getDate() < birthdate.getDate())
  ) {
    age--;
  }

  return age;
};
